import React, { useCallback, useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useLocation, useParams } from "react-router-dom";
import useCampaignStore, {
  pollingJoinCampaign,
  registerLineUserId,
} from "../../campaign/redux/campaign/store";
import { useNavigate } from "../../../../lib/hooks/useNavigate";
import {
  Container,
  ErrorContainer,
  SubmitContainer,
  GoTopButton,
  LoadingText,
  InfoText,
} from "../style/polling-campaign-join";
import {
  fetchCampaignData,
  fetchEarndCampaignData,
} from "../../../../common/utils/campaign";
import { Campaign, LineFriends } from "../../campaign/campaign.type";

export const PollingCampaignJoin: React.FC = () => {
  const { tenant_code } = useParams();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const [campaignId, setCampaignid] = useState<string | null>(
    query.get("campaign_id"),
  );
  const [lineFriendId, setLineFriendId] = useState<string | null>(
    query.get("line_friend_id"),
  );
  const [code, setCode] = useState<string | null>(query.get("code"));
  const [pollingStatus, setPollingStatus] = useState<
    "pending" | "success" | "failed" | "timeout"
  >("pending");
  const [fetchedCampaignData, setFetchedCampaignData] =
    useState<boolean>(false);
  const navigate = useNavigate();
  const filteredCampaigns = useCampaignStore(
    (state) => state.filteredCampaigns,
  );

  const isLogin = localStorage.getItem("t__mm_access_token") !== null;

  useEffect(() => {
    if (tenant_code) {
      fetchCampaignData(tenant_code, isLogin).then(() => {
        setFetchedCampaignData(true);
      });
    }
  }, [tenant_code]);

  const polingFriendAddCheck = useCallback(() => {
    if (campaignId && lineFriendId && tenant_code) {
      // 友達追加をモーダルで開く
      const campaign = filteredCampaigns.find(
        (campaign: Campaign) => campaign.id === parseInt(campaignId),
      );
      campaign?.line_friends?.forEach((friend: LineFriends) => {
        if (friend.id === parseInt(lineFriendId)) {
          window.open(friend.line_friend_url, "_blank", "noopener,noreferrer");
        }
      });
      // 友達追加を監視
      pollingJoinCampaign(tenant_code, parseInt(campaignId))
        .then((res) => {
          if (res.status === "success") {
            // Redirect to campaign page after successful registration
            fetchCampaignData(tenant_code, isLogin).then(() => {
              fetchEarndCampaignData().then(() => {
                window.location.href = `/${tenant_code}/campaign/${campaignId}?tab=participating`;
              });
            });
          }
        })
        .catch((error) => {
          setPollingStatus(error.status);
        });
    }
  }, [fetchedCampaignData, campaignId, lineFriendId, tenant_code]);

  useEffect(() => {
    if (
      code &&
      campaignId &&
      tenant_code &&
      fetchedCampaignData &&
      filteredCampaigns &&
      lineFriendId
    ) {
      registerLineUserId(
        tenant_code,
        code,
        parseInt(campaignId),
        parseInt(lineFriendId),
      )
        .then((res) => {
          polingFriendAddCheck();
        })
        .catch((error) => {
          setPollingStatus(error.status);
        });
    }
  }, [
    code,
    campaignId,
    tenant_code,
    fetchedCampaignData,
    filteredCampaigns,
    lineFriendId,
  ]);

  const handleGoTop = useCallback(() => {
    navigate(`/campaign`);
  }, []);

  const handleGotoLineFriend = useCallback(() => {
    // 友達追加をモーダルで開く
    if (lineFriendId && campaignId) {
      const campaign = filteredCampaigns.find(
        (campaign: Campaign) => campaign.id === parseInt(campaignId),
      );
      campaign?.line_friends?.forEach((friend: LineFriends) => {
        if (friend.id === parseInt(lineFriendId)) {
          location.href = friend.line_friend_url;
        }
      });
    }
  }, [lineFriendId, campaignId, filteredCampaigns]);

  return (
    <Container>
      {pollingStatus === "pending" && <CircularProgress />}
      <LoadingText>
        {pollingStatus === "pending"
          ? "ステータスを確認中..."
          : pollingStatus === "success"
            ? "登録を確認しました。"
            : pollingStatus === "failed"
              ? "登録が確認できませんでしました。お手数ですが、再度キャンペーンに参加してください。"
              : "タイムアウトしました。"}
      </LoadingText>

      {pollingStatus === "pending" && (
        <SubmitContainer>
          <InfoText>
            LINEが開かない場合は、
            <br />
            下記ボタンをタップして友達追加をしてください
          </InfoText>
          <GoTopButton
            onClick={(e) => {
              e.stopPropagation();
              handleGotoLineFriend();
            }}
          >
            友達登録をしてキャンペーンへ進む
          </GoTopButton>
        </SubmitContainer>
      )}

      {pollingStatus !== "pending" && (
        <ErrorContainer>
          <GoTopButton
            onClick={(e) => {
              e.stopPropagation();
              handleGoTop();
            }}
          >
            トップへ戻る
          </GoTopButton>
        </ErrorContainer>
      )}
    </Container>
  );
};
